import React, { useContext } from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { MyBetsBetContext } from "@state/context/my-bets/MyBetsBetContext";

export default observer(function BetCombinationsHeader(props: {
	setShowCombinations: (v: boolean) => void;
}) {
	const { t } = useTranslation();
	const bet = useContext(MyBetsBetContext);

	return (
		<div className="popup__header">
			<div className="popup__title u-type--base">
				{t<string>("mybets:ITEM.BET_SLIP_COMBINATIONS.TITLE", {
					0: bet.betSlipNumber,
				})}
			</div>
			<button
				type="button"
				onClick={() => props.setShowCombinations(false)}
				className="popup__close btn btn--square btn--square--xsml btn--primary--inverted btn--icon"
				title={t("COMMON.CLOSE")}
			>
				<i className="u-icon u-icon--tny u-icon--close" />
			</button>
		</div>
	);
});
